export const Banks = [
  { key: "Meli", value: "ملی" },
  { key: "Melat", value: "ملت" },
  { key: "Saderat", value: "صادرات" },
  { key: "Keshavarzi", value: "کشاورزی" },
  { key: "ُSepah", value: "سپه" },
  { key: "Dey", value: "دی" },
  { key: "MehreIran", value: "مهر ایران" },
  { key: "Mehr", value: "مهر" },
  { key: "Ayande", value: "آینده" },
  { key: "Tourism", value: "گردشگری" },
  { key: "Refah", value: "رفاه" },
  { key: "Tejarat", value: "تجارت" },
  { key: "ToseTavon", value: "توسعه تعاون" },
  { key: "ToseSaderat", value: "توسعه صادارت" },
  { key: "Saman", value: "سامان" },
  { key: "Pasargad", value: "پاسارگاد" },
  { key: "Parsian", value: "پارسیان" },
  { key: "Maskan", value: "مسکن" },
  { key: "Karafarin", value: "کارآفرین" },
];
